var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout new-calculation" },
    [
      _c("m-confirm", {
        attrs: {
          "modal-confirm": true,
          active: _vm.isShowConfirmModal,
          "modal-title": "",
          "modal-description":
            "На эту дату уже есть сохраненный расчет. Заменить его?",
          "confirm-button-label": "Сохранить",
        },
        on: {
          close: function ($event) {
            _vm.isShowConfirmModal = false
          },
          removeItemRequest: _vm.confirmRequestSaveCalculation,
        },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$route.query.calc_id
                  ? "Сохраненный расчет" +
                      (_vm.filialLocalValue && _vm.filialLocalValue.label
                        ? " по филиалу " +
                          _vm.filialLocalValue.label +
                          (_vm.periodLocalValue.length > 0
                            ? " за " +
                              _vm.$refs.calculationPeriod.period.start.input +
                              " - " +
                              _vm.$refs.calculationPeriod.period.end.input
                            : "")
                        : "")
                  : _vm.switcherLocalValue === "byDate"
                  ? "Новый расчет"
                  : _vm.switcherLocalValue === "byPeriod"
                  ? "Новая расчетная смена" +
                    (_vm.filialLocalValue && _vm.filialLocalValue.label
                      ? " по филиалу " +
                        _vm.filialLocalValue.label +
                        (_vm.periodLocalValue.length > 0
                          ? " за " +
                            _vm.$refs.calculationPeriod.period.start.input +
                            " - " +
                            _vm.$refs.calculationPeriod.period.end.input
                          : "")
                      : "")
                  : "Новый расчет"
              ) +
              " "
          ),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button", {
                attrs: {
                  size: "small",
                  responsive: true,
                  icon: "back",
                  type: "with-icon",
                  label: "К списку расчетов",
                },
                on: { click: _vm.openCalculationsList },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "new-calculation-params",
          class: {
            "new-calculation-params-required":
              _vm.dateSettlementErrorLocal.length > 0 ||
              _vm.timeStartErrorLocal.length > 0 ||
              _vm.timeEndErrorLocal.length > 0,
          },
        },
        [
          _c(
            "div",
            { staticClass: "new-calculation-params-part" },
            [
              _c("c-input", {
                staticClass: "new-calculation-params-filial",
                class: {
                  "new-calculation-params-filial-pb-30":
                    _vm.switcherLocalValue === "byPeriod",
                },
                attrs: {
                  type: "select",
                  searchable: true,
                  items: _vm.filialLocalItems,
                  placeholder: "Выберите филиал",
                  label: "Филиал",
                },
                model: {
                  value: _vm.filialLocalValue,
                  callback: function ($$v) {
                    _vm.filialLocalValue = $$v
                  },
                  expression: "filialLocalValue",
                },
              }),
              _c("c-switcher", {
                staticClass: "new-calculation-params-switcher",
                class: {
                  "new-calculation-params-switcher-pb-30":
                    _vm.switcherLocalValue === "byPeriod",
                },
                attrs: {
                  type: "group",
                  items: [
                    { label: "На дату", value: "byDate" },
                    { label: "За период", value: "byPeriod" },
                  ],
                },
                model: {
                  value: _vm.switcherLocalValue,
                  callback: function ($$v) {
                    _vm.switcherLocalValue = $$v
                  },
                  expression: "switcherLocalValue",
                },
              }),
              _vm.switcherLocalValue === "byPeriod"
                ? _c("c-input", {
                    ref: "calculationPeriod",
                    staticClass: "new-calculation-params-period",
                    class: {
                      "new-calculation-params-period-pb-30":
                        _vm.switcherLocalValue === "byPeriod",
                    },
                    attrs: {
                      label: "Период",
                      placeholder: "00.00.0000 - 00.00.0000",
                      type: "period-without-fixed-intervals",
                      icon: "calendar",
                      clearable: true,
                      "icon-right": true,
                      "required-message": _vm.periodLocalError,
                      required: _vm.periodLocalError,
                    },
                    model: {
                      value: _vm.periodLocalValue,
                      callback: function ($$v) {
                        _vm.periodLocalValue = $$v
                      },
                      expression: "periodLocalValue",
                    },
                  })
                : _vm._e(),
              _vm.switcherLocalValue === "byDate"
                ? _c("c-input", {
                    ref: "dateInputNewCalculation",
                    staticClass: "new-calculation-params-date-settlement",
                    attrs: {
                      label: "Расчeт на дату",
                      editable: true,
                      type: "date",
                      format: "DD.MM.YYYY, dddd",
                      icon: "calendar",
                      placeholder: "00.00.0000",
                      required: _vm.dateSettlementErrorLocal,
                      "icon-right": true,
                    },
                    on: { invalidDate: _vm.sendErrorDateMessage },
                    model: {
                      value: _vm.dateSettlementLocal,
                      callback: function ($$v) {
                        _vm.dateSettlementLocal = $$v
                      },
                      expression: "dateSettlementLocal",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "new-calculation-params-part" }, [
            _c(
              "div",
              { staticClass: "shift" },
              [
                _vm.switcherLocalValue === "byDate"
                  ? _c("c-input", {
                      staticClass: "new-calculation-params-shift-type",
                      attrs: {
                        type: "select",
                        placeholder: "Выберите тип смены",
                        items: _vm.shiftTypeLocalItems,
                        label: "Смена",
                      },
                      model: {
                        value: _vm.shiftTypeLocalValue,
                        callback: function ($$v) {
                          _vm.shiftTypeLocalValue = $$v
                        },
                        expression: "shiftTypeLocalValue",
                      },
                    })
                  : _vm._e(),
                _vm.switcherLocalValue === "byDate"
                  ? _c(
                      "div",
                      { staticClass: "new-calculation-params-time" },
                      [
                        _c("c-input", {
                          staticClass: "new-calculation-params-time-start",
                          class: {
                            "new-calculation-params-time-start-required":
                              _vm.timeStartErrorLocal.length > 0,
                          },
                          attrs: {
                            type: "text",
                            mask: "##:##",
                            placeholder: "00:00",
                          },
                          model: {
                            value: _vm.timeStart,
                            callback: function ($$v) {
                              _vm.timeStart = $$v
                            },
                            expression: "timeStart",
                          },
                        }),
                        _c("span", [_vm._v("−")]),
                        _c("c-input", {
                          staticClass: "new-calculation-params-time-end",
                          class: {
                            "new-calculation-params-time-end-required":
                              _vm.timeEndErrorLocal.length > 0,
                          },
                          attrs: {
                            type: "text",
                            mask: "##:##",
                            placeholder: "00:00",
                          },
                          model: {
                            value: _vm.timeEnd,
                            callback: function ($$v) {
                              _vm.timeEnd = $$v
                            },
                            expression: "timeEnd",
                          },
                        }),
                        _vm.timeErrorLocal.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "new-calculation-params-time-error-message",
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "new-calculation-params-time-error-message-icon",
                                    attrs: {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 14 14",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "7",
                                        cy: "7",
                                        r: "6.5",
                                        fill: "white",
                                        stroke: "#FF238D",
                                      },
                                    }),
                                    _c("circle", {
                                      attrs: {
                                        cx: "7",
                                        cy: "10",
                                        r: "1",
                                        fill: "#FF238D",
                                      },
                                    }),
                                    _c("rect", {
                                      attrs: {
                                        x: "6",
                                        y: "3",
                                        width: "2",
                                        height: "5",
                                        rx: "1",
                                        fill: "#FF238D",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "new-calculation-params-time-error-message-text",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.timeErrorLocal) + " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "new-calculation-params-buttons",
                class: {
                  "new-calculation-params-buttons-mt-0":
                    _vm.switcherLocalValue === "byPeriod",
                },
              },
              [
                _c("c-button", {
                  staticClass: "new-calculation-params-buttons-calc",
                  attrs: {
                    disabled: _vm.isDataLoading,
                    label:
                      _vm.switcherLocalValue === "byDate"
                        ? "Рассчитать"
                        : "Рассчитать",
                    color: "primary",
                  },
                  on: { click: _vm.calculate },
                }),
                _vm.switcherLocalValue === "byDate" && false
                  ? _c("c-button-dropdown", {
                      staticClass: "new-calculation-params-buttons-time",
                      attrs: {
                        type: "dropdown",
                        icon: "arrow",
                        dropdown: {
                          position: "left",
                          items: [
                            {
                              label: "На текущий момент",
                              emit: "calculate",
                              value: "now",
                            },
                            {
                              label: "С настройками на дату расчета",
                              emit: "calculate",
                              value: "past",
                            },
                          ],
                        },
                      },
                      on: { calculate: _vm.calculate },
                    })
                  : _vm._e(),
                !_vm.isDataLoading && _vm.isShowMainTable
                  ? _c("c-button-dropdown", {
                      staticClass: "new-calculation-params-buttons-time",
                      attrs: {
                        type: "dropdown",
                        icon: "arrow",
                        dropdown: {
                          position: "left",
                          items: [
                            {
                              label: "Рассчитать на сейчас",
                              emit: "calculate",
                              value: "calcnow",
                            },
                            {
                              label: "Печать",
                              emit: "calculate",
                              value: "print",
                            },
                            //  { label: 'Расчетный лист', emit: 'calculate', value: 'calc' },
                            {
                              label: "Для фото",
                              emit: "calculate",
                              value: "photo",
                            },
                            {
                              label: "Excel",
                              emit: "calculate",
                              value: "excel",
                            },
                          ],
                        },
                      },
                      on: { calculate: _vm.calculate },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "new-calculation-params-hide-show-block" },
              [
                !_vm.isDataLoading &&
                _vm.isShowMainTable &&
                _vm.tableData.columns.length > 0 &&
                _vm.tableData.records.length > 0
                  ? _c("c-button", {
                      attrs: {
                        disabled: _vm.isDataLoading,
                        label: _vm.isShowTable
                          ? "Скрыть таблицу"
                          : "Показать таблицу",
                        icon: "google-grey",
                        type: "with-icon",
                      },
                      on: { click: _vm.toggleTable },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm.isDataLoading
        ? _c("c-loader", {
            staticClass: "new-calculation-loader",
            attrs: {
              label: "Производится расчёт",
              active: _vm.isDataLoading,
              height: "500",
            },
          })
        : _vm._e(),
      !_vm.isDataLoading &&
      _vm.isShowMainTable &&
      _vm.tableData.columns.length > 0 &&
      _vm.tableData.records.length > 0 &&
      _vm.isShowTable
        ? _c("c-data-table-create-calculation", {
            ref: "table",
            staticClass: "new-calculation-table",
            attrs: {
              levels: 1,
              "personal-reasons": _vm.personalReasons,
              "calc-data": _vm.calcData,
              "disabled-columns": [],
              data: _vm.tableData,
              "drivers-columns": _vm.driversColumns,
              "production-columns": _vm.productionColumns,
              "drivers-columns-disabled": _vm.driversColumnsDisabled,
              "production-columns-disabled": _vm.productionColumnsDisabled,
            },
            on: {
              salmon: _vm.salmon,
              loadvalue: _vm.loadvalue,
              disabledColumnsEvent: _vm.disabledColumnsEvent,
            },
          })
        : _vm._e(),
      !_vm.isDataLoading && _vm.isShowMainTable
        ? _c(
            "div",
            { staticClass: "new-calculation-tabs" },
            [
              _c("c-tabs", {
                ref: "tab",
                attrs: {
                  active: _vm.activeTab,
                  items: _vm.tabs,
                  "with-routing": "",
                },
                on: { change: _vm.changeTab },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.isDataLoading && _vm.isShowMainTable
        ? _c(
            "div",
            { staticClass: "new-calculation-content" },
            [
              _c("router-view", {
                key: _vm.$route.path,
                ref: "route",
                attrs: {
                  chapter: _vm.activeTab,
                  "disabled-saved": _vm.disabledSaved,
                  "personal-reasons": _vm.personalReasons,
                  tab: _vm.switcherLocalValue,
                  "can-edit": _vm.canEdit,
                  data: _vm.calcData,
                  "change-calc": _vm.changeCalc,
                  "time-start": _vm.timeStart,
                  "time-end": _vm.timeEnd,
                  "drivers-columns": _vm.driversColumns,
                  "production-columns": _vm.productionColumns,
                  "drivers-columns-disabled": _vm.driversColumnsDisabled,
                  "production-columns-disabled": _vm.productionColumnsDisabled,
                  filialLocalValue: _vm.filialLocalValue,
                  "is-closed": _vm.isClosed,
                  "can-close": _vm.canClose && !!_vm.$route.query.calc_id,
                  "is-toggling-closed": _vm.isTogglingClosed,
                },
                on: {
                  toggleClosed: _vm.toggleCalculationClosed,
                  updateDriversCount: _vm.updateDriversCount,
                  updateKPItable: _vm.updateKPItable,
                  sendActivePosts: _vm.activatePosts,
                  saveCalculation: _vm.saveCalculation,
                  cancelCalculation: _vm.cancelCalculation,
                  changeDriver: _vm.changeDriver,
                  recountRoutes: _vm.recountRoutes,
                  disabledColumnsEvent: _vm.disabledColumnsEvent,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }